import { User } from '../../shared/user/user.model';
import { StudentService, Student } from '.';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpResponse } from '@angular/common/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import { FUZZY_SEARCH_DISTANCE } from '../../shared';

@Injectable()
export class StudentTypeaheadService {

    // in milliseconds
    readonly DEBOUNCE_TIME = 300;

    constructor(private studentService: StudentService) {
    }

    resultFormatter = (student: any) => student['label'];

    inputFormatter = (student: any, getUser: () => User) => {
        let user = getUser();
        if (user !== undefined) {
            return user['firstName'] + ' ' + user['lastName'];

        }
        return student['label'];
    }

    search = (text$: Observable<String>) =>
        text$
            .debounceTime(this.DEBOUNCE_TIME)
            .distinctUntilChanged()
            .switchMap(term => {
                if (term.length === 0 ) {
                    term = ' ';
                }
                let formattedQuery = term;
                if (term) {
                    formattedQuery = term.split(/[ ]+/).reduce((acumQuery, token) => {
                        let fuzzyToken =  token !== '' ? token + '~' + FUZZY_SEARCH_DISTANCE : '';
                        return acumQuery + ' ' + fuzzyToken;
                    }, '');
                }
                return this.studentService
                .search({ query: formattedQuery })
                .switchMap((res: HttpResponse<Student[]>) => Observable.of(res.body));
            })
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/student.typeahead.service.ts